$(document).ready(function(){
  
  Shopify.queue=[];
  
  Shopify.moveAlong = function() {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
    }
    // If the queue is empty, we will redirect to the cart page.
    else {
      document.location.href = '/cart';
    }
  };
  
  
  var variant_id=$('select[name=id]').val();
  var id=$('.frequently-bought-together').attr('data-handle');
  var variants=[];
  variants.push({
    id:variant_id,
    prod_name:$('h1.page-title').text(),
    handle:id,
    price:$('span.actual-price').text().replace('$',''),
    img:$('.photos:eq(0)').find('.photo:eq(0)').attr('href')
  });
  $.ajax({
    url:'/products/'+id+'?view=json',
    success:function(resp){
      	var v=JSON.parse(resp.trim());
      	
        var related=[];
        for(var i=0;i<v.metafields.related.length;i++){
			related.push(v.metafields.related[i]);
          	variants.push({});
        }
      	
        for(var i=0;i<related.length;i++){
          var ind=i+0;;
          var pcode=related[i].split('/');
          var ps={
            ind:ind+1,
            pc:pcode
          }
          linkCb(ps,function(a){
            
            $.getJSON('/products/'+a.pc[0]+'.json',function(r1){
              var ind2=a.ind+0;
              for(var i=0;i<r1.product.variants.length;i++){
                if(r1.product.variants[i].id==a.pc[1]){
                  variants[ind2]={
                    id:r1.product.variants[i].id,
                    handle:a.pc[0],
                    prod_name:r1.product.title,
                    price:r1.product.variants[i].price,
                    img:r1.product.image.src
                  };
                  break;
                }
              }
              callComplete(variants,function(vari){
                
              	populateFBP(vari);
              });
              

            });
          });	
        }
    }
  });

  
  
  $('.cbb-frequently-bought-add-button').on('click',function(){
    
    // google analytics tracking
    ga('send', 'event', 'Product-cbb', 'frequently-bought-add-button');
    
    Shopify.queue=[];
//     var items=$('.frequently-bought-together').find('.cbb-frequently-bought-selector-input:checked').size();
   
    $('.frequently-bought-together').find('.cbb-frequently-bought-selector-input:checked').each(function(){
       var par={
          variantId:$(this).attr('id'),
          quantity:1
        };
      	
      Shopify.queue.push(par);
    }).promise().done(function(){
    	Shopify.moveAlong();
    });
  });
  
  $("form.cart-form").on('click','div.single-option-selector li',function(){
    setTimeout(function(){
      populateFBP(variants);
    },100);
    
  })
  
});
function linkCb(a,b){
  	b(a);
  }
function callComplete(vari,b){
  var bool=true;
  for(var i=0;i<vari.length;i++){
    if(vari[i].id==undefined){
    	bool=false;
      	break;
    }
  }
  if(bool){
  	b(vari);
  }
}
function populateFBP(variants){
  var variant_title=$('select[name=id]').find('option:selected').text().split('-');
  variants[0]={
    id:$('select[name=id]').val(),
    //prod_name:$('h1.page-title').text()+ ' ' + (variant_title[0].trim()=='Default Title'?'':variant_title[0]),
    prod_name:$('h1.page-title').text(),
    handle:$('.frequently-bought-together').attr('data-handle'),
    price:parseFloat($('span.actual-price').text().replace('$','')),
    img:$('.photos:eq(0)').find('.photo:eq(0)').attr('href')
  };
  $('.frequently-bought-together').find('ul.cbb-frequently-bought-selector-list').html('');
  for(var i=0;i<variants.length&&i<3;i++){
	var cont=`
		<li class="cbb-frequently-bought-checkbox-wrapper" style=""><input type="checkbox" class="cbb-frequently-bought-selector-input" id="`+variants[i].id+`" data-index="`+i+`" name="product_`+(i+1)+`" checked="checked" style="display: inline;">
			<div class="item-detail" style="">
              <span class="cbb-frequently-bought-selector-label" for="21402902535" style="">
                <span class="cbb-frequently-bought-selector-label-name" style="">`+(i==0?`<strong>This item:</strong> `:``)+variants[i].prod_name+`</span>
              </span>
              <span class="cbb-frequently-bought-selector-label-price money" style="">
                <span class="money">$`+parseFloat(variants[i].price)+`</span>
              </span>
              <s class="cbb-frequently-bought-selector-label-compare-at-price" style=""></s>
			</div>
        </li>
	`;
    $('.frequently-bought-together').find('ul.cbb-frequently-bought-selector-list').append(cont);
  }
  renderFBP(variants);
  $('.cbb-frequently-bought-selector-input').on('click',function(){
    var cb=this;
    if(!$(this).prop('checked')){
      $(this).parents('li').find('.item-detail').animate({opacity:'0.5'},200);
      var el=$('ul.cbb-frequently-bought-products').find('li[data-variantid='+$(this).attr('id')+']');
      $(el).animate({opacity:'0'},500,function(){
      	renderFBP(variants);
      })
      
      var allChecked = false;
      $('.cbb-frequently-bought-selector-input').each(function() {
        if($(this).prop('checked')) {
          allChecked = true;
        }
      });
      if(allChecked === false) {
        setTimeout(clearPrice, 550);
      }
    }else{
      $(this).parents('li').find('.item-detail').animate({opacity:'1'},200);
      if($('ul.cbb-frequently-bought-products').find('li[data-variantid='+$(this).attr('id')+']').size()<=0){
      	var ind=$(cb).parents('li').index();
        renderFBP(variants,function(){
          $('ul.cbb-frequently-bought-products').find('li:eq('+ind+')').css('opacity','0').animate({opacity:'1'});
        });
      }
      $('.cbb-frequently-bought-add-button').prop('disabled', false);
      $('.cbb-frequently-bought-total-price-box').show();
      $('.cbb-frequently-bought-add-button').find('span').text('Add Selected to Cart');
    }
    
  });
  $('.frequently-bought-together').show();
}

function renderFBP(variants,callback){
  var prd=[];
  $('.frequently-bought-together').find('.cbb-frequently-bought-selector-input:checked').each(function(){
  	prd.push(variants[parseInt($(this).attr('data-index'))]);
  }).promise().done(function(){
    $('.frequently-bought-together').find('.cbb-frequently-bought-products').html('');
    var total=0;
    for(var i=0;i<prd.length;i++){

    	var cont=`
          <li class="cbb-frequently-bought-product" data-variantid="`+prd[i].id+`" style="">
            <a href="/products/`+prd[i].handle+`?variant_id=`+prd[i].id+`">
              <div class="cbb-frequently-bought-product-image" style="background-image: url('`+prd[i].img+`');"></div>
            </a>
			<span class="plus-icon" style="">+</span>
          </li>
		`;
      total+=parseFloat(prd[i].price);
      final_total = total.toFixed(2);
      $('.frequently-bought-together').find('.cbb-frequently-bought-products').append(cont);
    }
    $('.cbb-frequently-bought-total-price-price').find('.money').text('$'+final_total);
    $('.frequently-bought-together').find('.cbb-frequently-bought-products').find('li:last').find('.plus-icon').hide();
    if(callback!=undefined){
    	callback();
    }
  });
}

function addtocart(data,callback){
	$.ajax({
        url:'/cart/add.js',
        data:par,
        dataType:'json',
        success:function(resp){
          var resp={
            status:'success',
            response:resp
          };
          callback(resp);
        },
        error:function(err){
          var resp={
            status:'error'
          }
          callback(resp);
        }
      }); 
}


// clear price, disable button if all unchecked

function clearPrice(){
 $('.cbb-frequently-bought-total-price-box').hide();
 $('.cbb-frequently-bought-add-button').prop('disabled', true);
 $('.cbb-frequently-bought-add-button').find('span').text('Use Checkbox to Add Items');
  
}

//on load if window <= 768 put add to cart below
if(Modernizr.mq('(max-width: 767px)')) {
  $('.cbb-frequently-bought-form').insertAfter('.cbb-frequently-bought-selector-list');
}
// reorder add to cart if mobile or window size resizes <= 768
$(window).resize(function(){
  if(Modernizr.mq('(max-width: 767px)')) {
    $('.cbb-frequently-bought-form').insertAfter('.cbb-frequently-bought-selector-list');
  } else {
   	$('.cbb-frequently-bought-form').insertBefore('.cbb-frequently-bought-selector-list'); 
  }
});
